module.exports = __webpack_public_path__ + "static/img/technologyu01.f8c15f4f.svg";